/**
 * Kurzes Vibrieren als Rückmeldung — beim Öffnen des Mikrofons und wenn die
 * Kamera einen Showcase erkennt. Nur, wo das Gerät es kann (Android); iOS
 * kennt die API im Browser nicht und bleibt still. Fehler werden verschluckt:
 * Eine fehlende Vibration ist kein Fehler, den jemand sehen muss.
 */
export function vibrate(pattern: number | number[] = 20): void {
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
      navigator.vibrate(pattern)
    }
  } catch {
    /* ohne Vibration weiter */
  }
}

/** Mikrofon geöffnet: ein kurzer Tick. */
export const VIBRATION_MIKRO = 15
/** Showcase erkannt: zweimal kurz — „hab ihn". */
export const VIBRATION_ERKANNT = [30, 60, 30]
